// extracted by mini-css-extract-plugin
module.exports = {"red":"Nickname_red__2zeB_","blue":"Nickname_blue__1fwg_","default":"Nickname_default__1m5HW","gray":"Nickname_gray__dSI8a","viewer":"Nickname_viewer__2Ajny"};